export default __webpack_public_path__ + "static/media/admin.78492f0a.less";